import useFetch from '@hooks/useFetch';
import { useMemo } from 'react';

const processURLs = (data = {}) => {
  return {
    unLiveURL: data?.unliveUrl,
    subjectiveTestEvalURL: data?.subjectiveTestSeriesUrl,
    liveMentoringUrl: data?.liveRoom1On1Url,
    liveRoomRecordingUrl: data?.liveRoomRecordingUrl,
    doubtsBrowseUrl: data?.doubtBrowseUrl,
    lmpAddToCanvas: data?.lmpAddToCanvasEnable,
    lmpWebUrl: data?.lmpWebUrl,
    educatorDriveUrl: data?.educatorDriveUrl
  };
};

const useURLs = (selector) => {
  const key = 'v1/constants/extras/';
  const { data: urls, ...rest } = useFetch(key);
  const processedURLs = useMemo(() => {
    if (urls) return processURLs(urls);
    return {};
  }, [urls]);
  if (typeof selector === 'function') return selector(processedURLs);
  return { urls: processedURLs, ...rest };
};

export default useURLs;
